/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from '../BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

const __vue_script__ = {
    name: 'LocaleSelector',

    components: { BaseSelect },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            required: true
        },

        value: {
            type: String,
            default: ''
        },

        name: {
            type: String,
            default: 'locale'
        },
    },

    computed: {
        enabled() {
            return this.$services.user.isBetaTester() && this.localeOptions.length > 1;
        },

        innerValue: {
            get() {
                return this.value;
            },

            set(value) {
                this.$emit('input', value);
            }
        },

        localeOptions() {
            const allLang = this.$utils.locales.getAllLanguages();
            const defaultLang = this.event.languages?.[0] || 'en';
            const localeOptions = this.event.languages?.map(lang => {
                const { englishName: label } = allLang[lang];
                return { label, value: lang, default: lang === defaultLang };
            }) || [];

            localeOptions.sort((a, b) => a.label.localeCompare(b.label));
            return localeOptions;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('div',{staticClass:"locale-selector"},[_c('base-select',{attrs:{"label":_vm.label,"tip":_vm.tip,"allow-empty":false,"name":_vm.name,"options":_vm.localeOptions,"track-by":"value","emit-option-value-only":"emit-option-value-only"},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(option.label))]),(option.default)?_c('span',{staticClass:"default"},[_vm._v(_vm._s(_vm.$t('general.forms.labels.default_locale')))]):_vm._e()]}},{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('span',[_vm._v(_vm._s(option.label))]),(option.default)?_c('span',{staticClass:"default"},[_vm._v(_vm._s(_vm.$t('general.forms.labels.default_locale')))]):_vm._e()]}}],null,false,546829270),model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}}),(_vm.hint)?_c('div',{staticClass:"control-hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LocaleSelector.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__